import CancelAssessment from "../../../../assets/images/pre-assessment.svg";
import { getTranslatedText } from "../../../../utils/getTranslatedText";

import Modal from "../../../modal/Modal";

import Button from "../ButtonComponent";

import { BUTTON_VARIANTS } from "../constant";
import { useGetTranslatedText } from "../queries";

import styles from "./styles.module.scss";

const FeedbackRequiredModal = (props) => {
  const {show , handleGiveFeedBack , handleExit} = props;

  const languageId = localStorage.getItem("l_id") || 1;
  
  const {data:translatedTextResponse} = useGetTranslatedText(languageId);
          
  const {data:translatedText = []} = translatedTextResponse || {};

  return (
    <>
      <Modal visible={show}>
        <div className={styles["feedback-wrapper"]}>
          <div className={styles["success-image"]}>
            <img src={CancelAssessment} alt="success" />
          </div>
          <div className={styles.title}>{getTranslatedText(translatedText,"key_feedback_required","Feedback Required")}</div>
          <div className={styles.description}>
            {getTranslatedText(translatedText,"key_feedback_content","Feedback submission is required to complete this learning. Please proceed by submitting your feedback.")}
          </div>

          <div className={styles["button-wrapper"]}>
            <Button
              label={getTranslatedText(translatedText , "key_give_feedback" ,"Share Feedback")}
              buttonVariant={BUTTON_VARIANTS.PRIMARY}
              onClick={handleGiveFeedBack}
            />
            <Button
              label={getTranslatedText(translatedText, "key_btn_exit" ,"Exit")}
              buttonVariant={BUTTON_VARIANTS.SECONDARY}
              onClick={handleExit}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FeedbackRequiredModal;
